import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import "./ChatSidebar.css";

interface ChatSidebarProps {
  sessions: any[];
  createNewChat: () => void;
  handleSessionClick: (sessionId: string) => void;
  isMenuOpen: boolean;
  formatDate: (date: string) => string;
}

const ChatSidebar: React.FC<ChatSidebarProps> = ({
  sessions,
  createNewChat,
  handleSessionClick,
  isMenuOpen,
  formatDate,
}) => {
  return (
    <div className={`menu ${isMenuOpen ? "open" : ""}`}>
      <h2>CHATS</h2>
      <button onClick={createNewChat} className="new-chat-button">
        <FontAwesomeIcon icon={faAdd} />
        <span className="button-text">Crear Nuevo Chat</span>
      </button>

      <ul>
        {sessions.map((session, index) => (
          <li key={session.SessionChat}>
            <button onClick={() => handleSessionClick(session.SessionChat)}>
              Chat {index + 1} - {formatDate(session.Date)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChatSidebar;
